export type NormalizedPosition = "UTG" | "MP" | "CO" | "BTN" | "SB" | "BB" | "unknown";

export function normalizePosition(raw: string | null | undefined): NormalizedPosition {
  if (!raw) return "unknown";
  const s = raw.toUpperCase();
  if (s.includes("BTN") || s.includes("庄") || s.includes("BUTTON")) return "BTN";
  if (s.includes("SB") && !s.includes("BB")) return "SB";
  if (s.includes("BB") || s.includes("大盲") || s.includes("盲位")) return "BB";
  if (s.includes("UTG") || s.includes("前位") || s.includes("枪口") || s.includes("EP")) return "UTG";
  if (s.includes("CO") || s.includes("庄前")) return "CO";
  if (s.includes("MP") || s.includes("HJ") || s.includes("LJ") || s.includes("中")) return "MP";
  if (s.includes("后位") || s.includes("LP") || s.includes("有利位置")) return "BTN";
  if (s === "IP" || s === "OOP") return "unknown";
  return "unknown";
}
